// extracted by mini-css-extract-plugin
export default {"promo_wrapper":"B5","disabled":"C5","spinner":"E5","codes":"F5","item":"G5","remove":"H5","promo":"I5","apply":"J5"};
    if(module.hot) {
      // 1726593108108
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  